<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'展示情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'展示情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button *ngIf="userType!=USER_TYPE_USER || (userType==USER_TYPE_USER && isEdit)" mat-raised-button color="primary" (click)="addExhibit()" [disabled]="!exhibitFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="exhibitFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">ID</mat-label>
              <input [ngModel]="inExhibitId" matInput placeholder="ID" id="exhibitId" formControlName="exhibitId"
                maxlength="6" (ngModelChange)="inExhibitId = $event.toUpperCase()">
              <mat-error *ngIf="exhibitIdControl.invalid">{{ getErrorMessageToExhibitId() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'属性' | translate}}</mat-label>
              <mat-select placeholder="{{'属性' | translate}}" id="exhibitAttributeId"
                formControlName="exhibitAttributeId">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let exhibitAttribute of (exhibitAttributes | async)"
                  [value]="exhibitAttribute.attribute_id">
                  {{ exhibitAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <mat-form-field>
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="exhibitNames"
              value="{{ exhibit!.exhibit_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExhibitNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="exhibitNamesControl.invalid">{{ getErrorMessageToExhibitNames() }}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="exhibitDescs" rows="3"
              value="{{ exhibit!.exhibit_descs | multiDesc:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openExhibitDescDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="exhibitDescsControl.invalid">{{ getErrorMessageToExhibitDescs() }}</mat-error>
          </mat-form-field>

          <google-map *ngIf="center" height="400px" width="100%" step="0.00000001" [center]="center" [zoom]="zoom"
            [options]="options">
            <map-marker #markerElem *ngIf="currentPosition" step="0.00000001" [position]="currentPosition"
              [options]="currentPositionMarkerOption" (mapDragend)="onMerkerDragEnd($event)">
            </map-marker>
          </google-map>
          <input #mapSearchField class="map-search-field" type="text"
            (keydown)="onKeyDownFromSearchPlace($event.keyCode)" />
          <button #mapSearchFieldExecute (click)="searchMap()">{{'移動' | translate}}</button>
          <button #mapSearchFieldClear (click)="clearMapSearchField()">{{'クリア' | translate}}</button>

          <div class="exhibit-area" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'緯度' | translate}}</mat-label>
              <input matInput placeholder="{{'緯度' | translate}}" id="exhibitLat" formControlName="exhibitLat"
                type="number" step="0.00000001" (change)="onBlurMarkerLat()">
              <mat-error *ngIf="exhibitLatControl.invalid">{{ getErrorMessageToHallLat() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'経度' | translate}}</mat-label>
              <input matInput placeholder="{{'経度' | translate}}" id="exhibitLng" formControlName="exhibitLng"
                type="number" step="0.00000001" (change)="onBlurMarkerLng()">
              <mat-error *ngIf="exhibitLngControl.invalid">{{ getErrorMessageToHallLng() }}</mat-error>
            </mat-form-field>
          </div>

          <mat-checkbox formControlName="showMarker" color="primary">{{'MAPページに位置を表示する' |
            translate}}</mat-checkbox>
        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <mat-checkbox formControlName="notOverlapGuide" color="primary">{{'画像の上に詳細概要を重ねない' |
            translate}}</mat-checkbox>

          <div class="exhibit-files">
            <div class="exhibit-files-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'展示画像ファイル' | translate}}（ {{ !!exhibit!.exhibit_files ?
                exhibit!.exhibit_files.length:0 }} {{'件' | translate}}）</span>
              <button mat-stroked-button (click)="openSelectFilesDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'ファイル追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>{{'画像' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th style="width: 100px;">{{'言語' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDrop($event)">
                <tr *ngFor="let exhibitFile of exhibitFiles; let i=index" cdkDrag cdkDragLockAxis="y">
                  <td><img [src]="exhibitFile.download_url" height="40px" width="auto"></td>
                  <td>{{ exhibitFile.file_name }}</td>
                  <td>
                    <mat-select id="lang" [value]="exhibitFile.lang_code"
                      (selectionChange)="changeExhibitFileLang(i, $event)">
                      <ng-container *ngFor="let language of projectLanguages">
                        <mat-option [value]="language.lang_code">
                          {{ currentLang == 'en' ?  (language.lang_name_en ? language.lang_name_en : (language.lang_name | translate)): language.lang_name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteFiles(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <mat-checkbox formControlName="useYoutube" color="primary">{{'YouTubeを使用する' |
            translate}}</mat-checkbox>

          <mat-form-field>
            <mat-label floatLabel="always">{{ 'Youtube埋め込みコード' | translate }}</mat-label>
            <input matInput placeholder="{{ 'Youtube埋め込みコード' | translate }}" id="youtubeCodes"
              value="{{ exhibit!.youtube_codes | multiCode:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openYoutubeCodeDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <mat-checkbox formControlName="useExternallink" color="primary">{{'外部リンクを使用する' |
            translate}}</mat-checkbox>

          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンク名称' | translate}}</mat-label>
            <input matInput placeholder="{{'外部リンク名称' | translate}}" id="externallinkNames"
              value="{{ exhibit!.externallink_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンクＵＲＬ' | translate}}</mat-label>
            <input matInput placeholder="{{'外部リンクＵＲＬ' | translate}}" id="externallinkUrls"
              value="{{ exhibit!.externallink_urls | multiCode:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkUrlDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <div class="reservation-facility-list">
            <div class="reservation-facility-list-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'展示詳細リスト（' | translate}} {{ !!exhibit!.exhibit_detail_ids ? exhibit!.exhibit_detail_ids.length:0
                }} {{'件）' | translate}}</span>
              <button mat-stroked-button (click)="openSelectExhibitDetailsDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'展示詳細リスト追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{{'名称' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropExhibitDetail($event)">
                <tr *ngFor="let exhibitDetail of exhibitDetails" cdkDrag cdkDragLockAxis="y">
                  <td>{{ exhibitDetail.exhibit_detail_id }}</td>
                  <td>{{ exhibitDetail.exhibit_detail_names | multiName:projectLanguages:projectBaseLang }}</td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteExhibitDetail(exhibitDetail.id!)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="reservation-facility-list">
            <div class="reservation-facility-list-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'予約施設リスト（' | translate}} {{ !!exhibit!.reservation_facility_ids ?
                exhibit!.reservation_facility_ids.length:0 }} {{'件）' | translate}}</span>
              <button mat-stroked-button (click)="openSelectReservationFacilitiesDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'予約施設リスト追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>{{'ID' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropReservationFacility($event)">
                <tr *ngFor="let reservationFacility of reservationFacilities" cdkDrag cdkDragLockAxis="y">
                  <td>{{ reservationFacility.reservation_facility_id }}</td>
                  <td>{{ reservationFacility.reservation_facility_names | multiName:projectLanguages:projectBaseLang }}</td>
                  <td>
                    <button mat-stroked-button color="warn"
                      (click)="deleteReservationFacility(reservationFacility.id!)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

    </form>
  </div>

</div>